(function () {
  var routeMap = {
    '/products/collector-set': { path: '/pages/collector-set', edition: null },
    '/products/discovery-set': { path: '/pages/discovery-set', edition: null },
    '/products/well-suited-ltd-edition': { path: '/pages/well-suited-limited-edition', edition: null },
    '/products/miss-behaviour-ltd-edition': { path: '/pages/miss-behaviour-limited-edition', edition: null },
    '/products/notable-ltd-edition-copy': { path: '/products/notable', edition: 'limited' },
    '/products/soul-purpose-ltd-edition': { path: '/products/soul-purpose', edition: 'limited' },
    '/products/pink-reign-50ml': { path: '/products/pink-reign', edition: null }
  };

  function copyPreviewParams(fromUrl, toUrl) {
    ['preview_theme_id', '_ab', '_fd', '_sc'].forEach(function (key) {
      if (fromUrl.searchParams.has(key)) {
        toUrl.searchParams.set(key, fromUrl.searchParams.get(key));
      }
    });
  }

  function mappedUrl(rawUrl) {
    try {
      var source = new URL(rawUrl, window.location.origin);
      var mapping = routeMap[source.pathname];
      if (!mapping) return null;

      var target = new URL(mapping.path, window.location.origin);
      copyPreviewParams(new URL(window.location.href), target);
      if (mapping.edition) target.searchParams.set('edition', mapping.edition);
      target.hash = source.hash;
      return target.pathname + target.search + target.hash;
    } catch (e) {
      return null;
    }
  }

  var current = new URL(window.location.href);
  if (routeMap[current.pathname]) {
    var redirect = mappedUrl(current.href);
    if (redirect) {
      window.location.replace(redirect);
      return;
    }
  }

  function rewrite(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var anchors = scope.querySelectorAll ? scope.querySelectorAll('a[href*="/products/"]') : [];

    anchors.forEach(function (anchor) {
      var nextUrl = mappedUrl(anchor.href);
      if (!nextUrl) return;
      anchor.href = nextUrl;

      var card = anchor.closest('product-card');
      if (card) {
        card.querySelectorAll('.quick-add, quick-add-component, [data-quick-add]').forEach(function (quickAdd) {
          quickAdd.style.display = 'none';
        });
      }
    });
  }

  function start() {
    rewrite(document);
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) rewrite(node);
        });
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();


